"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var shop_1 = require("./shop");
exports.ShopService = shop_1.ShopService;
var product_1 = require("./product");
exports.ProductService = product_1.ProductService;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/shop/services/index.js
// module id = 355
// module chunks = 0